module.exports = __webpack_public_path__ + "img/mercado-pago-lg.1d5bf3ca.png";